module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.goEdit
    }
  }, [_vm._v(_vm._s(_vm.$t('app_editpasg')))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    staticClass: "gPageBorder gTopMg"
  }, [_c('el-row', {
    staticClass: "gPdTB"
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    staticClass: "gShowLeftForm",
    attrs: {
      "label-position": "left",
      "label-width": "17%"
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "calc(100% - 10px)"
    },
    attrs: {
      "label": "APPID"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.detail.appid) + "\n              ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowLeftForm",
    attrs: {
      "label-position": "left",
      "label-width": _vm.labelttw
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_psgname')
    }
  }, [_vm._v("\n                " + _vm._s(_vm.detail.appname) + "\n              ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowRightForm",
    attrs: {
      "label-position": "left",
      "label-width": _vm.labelttw
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_distributor')
    }
  }, [_vm._v("\n                " + _vm._s(_vm.detail.merchantName) + "\n              ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowLeftForm",
    attrs: {
      "label-position": "left",
      "label-width": _vm.labelttw
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_authstat')
    }
  }, [_c('tagc', {
    attrs: {
      "tagobj": {
        type: 'openAuthType',
        vl: _vm.detail.isauthen + ''
      }
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowRightForm",
    attrs: {
      "label-position": "left",
      "label-width": _vm.labelttw
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_cbackad')
    }
  }, [_vm._v("\n                " + _vm._s(_vm.detail.callbackurl) + "\n              ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    staticClass: "gShowLeftForm",
    attrs: {
      "label-position": "left",
      "label-width": "17%"
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "calc(100% - 10px)"
    },
    attrs: {
      "label": _vm.$t('app_bsrqsadwl')
    }
  }, _vm._l((_vm.detail.limitIp), function(item, index) {
    return _c('el-tag', {
      key: index,
      attrs: {
        "type": "primary"
      }
    }, [_vm._v(_vm._s(item))])
  }))], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    staticClass: "gShowLeftForm",
    attrs: {
      "label-position": "left",
      "label-width": "17%"
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "calc(100% - 10px)"
    },
    attrs: {
      "label": _vm.$t('app_appwtls')
    }
  }, _vm._l((_vm.detail.packageName), function(item, index) {
    return _c('el-tag', {
      key: index,
      attrs: {
        "type": "primary"
      }
    }, [_vm._v(_vm._s(item))])
  }))], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-54d505ea"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/openpl/detail.vue
// module id = 1041
// module chunks = 0